import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const AccountPage = lazy(() =>
  import("./pages/AccountPage").then((m) => ({ default: m.AccountPage }))
);

export const AccountRoutes: RouteObject = {
  path: "/account",
  children: [
    {
      index: true,
      element: <AccountPage />,
    },
  ],
};
